import Axios from "axios";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Form,
  Button,
  Input,
  Label,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import BackComponent from "../BackComponent";
import { UserContext } from "../userComponents/UserContext";

const data = {
  movies: null,
  id: null,
  title: "",
  description: "",
  duration: "",
  year: "",
  genre: "",
  rating: "",
  review: "",
  image_url: "",
  statusForm: "",
};
const FormTableMovies = (props) => {
  const [input, setInput] = useState(data);
  const [user] = useContext(UserContext);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    const url = `https://backendexample.sanbersy.com/api/data-movie`;
    Axios.post(
      url,
      {
        title: input.title,
        description: input.description,
        duration: input.duration,
        year: input.year,
        genre: input.genre,
        rating: input.rating,
        review: input.review,
        image_url: input.image_url,
      },
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    )
      .then((res) => {
        history.push("/movies");
        console.log(res.response);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setInput((beforeValue) => ({
      ...beforeValue,
      [id]: value,
    }));
    console.log([id]);
  };

  return (
    <Container>
      <Row>
        <Col md="8" className="mx-auto mt-5">
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Title :</Label>
              <Input
                type="text"
                id="title"
                placeholder="Input Title"
                onChange={handleChange}
                value={input.title}
              />
            </FormGroup>
            <FormGroup>
              <Label>Description :</Label>
              <Input
                type="text"
                id="description"
                placeholder="Input Description"
                onChange={handleChange}
                value={input.description}
              />
            </FormGroup>
            <FormGroup>
              <Label>Genre :</Label>
              <Input
                type="text"
                id="genre"
                placeholder="Input Genre"
                onChange={handleChange}
                value={input.genre}
              />
            </FormGroup>
            <FormGroup>
              <Label>Year :</Label>
              <Input
                type="number"
                id="year"
                placeholder="Input Year"
                onChange={handleChange}
                value={input.year}
              />
            </FormGroup>
            <FormGroup>
              <Label>Duration :</Label>
              <Input
                type="number"
                id="duration"
                placeholder="Input Duration"
                onChange={handleChange}
                value={input.duration}
              />
            </FormGroup>
            <FormGroup>
              <Label>Rating :</Label>
              <Input
                type="number"
                id="rating"
                placeholder="Input Rating"
                onChange={handleChange}
                value={input.rating}
              />
            </FormGroup>
            <FormGroup>
              <Label>Review :</Label>
              <Input
                type="text"
                id="review"
                placeholder="Input Review"
                onChange={handleChange}
                value={input.review}
              />
            </FormGroup>
            <FormGroup>
              <Label>Image Url :</Label>
              <Input
                type="text"
                id="image_url"
                placeholder="Input Image_Url"
                onChange={handleChange}
                value={input.image_url}
              />
            </FormGroup>
            <Button type="submit" className="primary mb-2">
              Submit
            </Button>
            <BackComponent />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default FormTableMovies;
